import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppRouteConstants } from 'src/app/shared/constants/app-route.constants';
import { AuthGuardService } from 'src/app/shared/services/auth-guard.service';
import { SessionManagement } from './components/session-management/session-management.component';


const routes: Routes = [
    {
        path: AppRouteConstants.DEFAULT, component: SessionManagement, pathMatch: 'full', canActivate: [AuthGuardService]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SessionEngagementRoutingModule { }


